import { LitElement, html, css } from "lit-element";

class LitVideoteal extends LitElement {

    static get properties() {
      return {
        assets: { type: Object },
        placement: {type: String}
      };
    }

    async setup(userHasAccess){
        var teal, elements, settings, pageData, data;
        const videoData = this.assets,
            utils = ga_data.utils,
            getNested = utils.getNested,
            route = ga_data.route,
            site = ga_data.site,
            videoPlacements = getNested(site, 'video', 'placements') || {},
            placement = this.placement || 'teal-default',
            placementconfig  = videoPlacements[placement] || {},
            defaultconfig = videoPlacements['default'],
            noAds = route.noAdvertising || utils.getUrlParamValue('no_ads') || utils.isAdFreeExperience() || !userHasAccess,
            pOrigin = getNested(route, 'sourceOrganization', 'name'),
            dfp = site.ads.dfp;
        window.gciAnalyticsUAID = ga_data.site.uaid + '-TEALIUM-UW';

        const pData = {
            adTargeting: {
              customParams: {},
              simpleTarget: window.simpleTarget ? window.simpleTarget : []
            },

            // // video specific meta
            awsPath: videoData.awsPath,
            id: videoData.id,
            keywords: videoData.keywords,
            section: videoData.ssts.section,
            section: videoData.ssts.section,
            series: videoData.series,
            subsection: videoData.ssts.subsection,
            subtopic: videoData.ssts.subtopic,
            topic: videoData.ssts.topic,
            origin: videoData.origin,
            pOrigin: pOrigin,

            baseName: site.baseName,
            displayName: site.publicationName,
            pageType: 'video',
            publicationName: site.publicationName,
            siteCode: site.uaid,

            // Third party
            twitter: site.twitter.primary_account
        };

        teal = new window.Teal.Player(

            elements = {
                video: this.shadowRoot.getElementById('tealPlayer'),
                container: this.shadowRoot.getElementById('tealContainer'),
                adContainer: this.shadowRoot.getElementById('adContainer')
            },
            settings = {
                base: {
                    debug: true,
                    autoplay: placementconfig.autoplay || defaultconfig.autoplay || false,
                    startMuted: placementconfig.autoplayMuted || defaultconfig.autoplayMuted || false,
                    startedBy: placementconfig.startedBy || 'user-click',
                    closedCaption: true,
                    placement: placement || '',
                    maxAdDuration: 120000,
                    minAdDuration: 0,
                    plcmt: placementconfig.plcmt || 2,
                    vpa: 'preroll'
                },
                ias: {
                    load: userHasAccess,
                    enable: userHasAccess
                },
                ima: {
                    load: !noAds,
                    enable: !noAds,
                    accountId: dfp.accountId,
                    accountName: dfp.accountName,
                    mobileAccountName: dfp.mobileAccountName,
                    mobilePlacement: placementconfig.adPlacementMobile || 'preroll-video',
                    targetingConsent: window.ga_privacy && window.ga_privacy.ccpaApplies && window.ga_privacy.targeting === false ? false : true,
                    gdprApplies: (userHasAccess)?false: this.gdprApplies,
                    tcString: (userHasAccess)?'': this.tcString,
                },
                gcianalytics: {
                    load: userHasAccess,
                    enable: userHasAccess
                },
                comscore: {
                    load: userHasAccess,
                    enable: userHasAccess
                },
                heartbeat: {
                    enable: false
                },
                hls: {
                    load: true,
                    enable: true
                },
                controls: {
                    enable: true,
                    enableBigPlayButton: true
                },
                continuousPlay: {
                    encore: placementconfig.continuousPlay || defaultconfig.continuousPlay || true
                },
                share: {
                    enableShareAPI: true
                },
                parsely: {
                    load: userHasAccess,
                    enable: userHasAccess,
                    scriptUrl: 'https://cdn.parsely.com/keys/' + site.baseName + '.com/p.js'
                }
            },
            pageData = pData,
            data = videoData
        );
    }

    script(srcpath) {
      let script = document.createElement('script');
      script.onload = this.onLoad.bind(this);
      script.src = srcpath;
      return script;
    }

    onLoad() {
      // this.setup();
      ga_data.utils.isEUuserRestrictedAccess().then(tcData => {
        const choices = ga_data.utils.getPrivacyChoices();
        if (!tcData.gdprApplies || (tcData.gdprApplies && choices.targeting === true)){
          this.gdprApplies = tcData.gdprApplies;
          this.tcString = tcData.tcString;
          this.setup(true); // User is authorized to get full access to video play
        } else {
          this.setup(false); // User is not authorized to get full access to video play
        }
      });
    }


    render() {
      return html`
        <link rel="stylesheet" href="https://www.gannett-cdn.com/gannett-web/apps/teal/dist/tealplayer-9f9a4bfe.min.css">
        <div id="tealContainer" class="teal-video-wrap">
              <video playsinline id="tealPlayer" poster="${this.assets.videoStill}">
              </video>
              <div id="adContainer" class="tealplayer-ad-container"></div>
        </div>
        ${this.script('https://www.gannett-cdn.com/gannett-web/apps/teal/dist/bundle-4b7a3256.js')}
      `;
    }
}

customElements.define("lit-videoteal", LitVideoteal);
